module.exports = __webpack_public_path__ + "img/14.20716be8.jpg";